import type { SerializedAllFeaturesEditorState } from '@/admin/lexical/features'
import type { Maybe } from '@/frontend-types'
import type { FC } from 'react'
import { ButtonLink } from '../atoms/ButtonLink'
import { InfoStrip } from '../atoms/InfoStrip'
import ContentBlockWrapper from '../molecules/ContentBlockWrapper'
import { RenderLexicalContent } from '../RenderContentBlocks'

export type VenueOverviewBlockProps = {
	overviewId: string
	introContent: SerializedAllFeaturesEditorState | null | undefined
	procurementUrl?: Maybe<string>
	location: string
	locationLink?: string
	firstNationsLocation?: Maybe<string>
	projectStatus?: string
	infoContent: SerializedAllFeaturesEditorState | null | undefined
}

export const VenueOverviewBlock: FC<VenueOverviewBlockProps> = ({
	overviewId,
	introContent,
	procurementUrl,
	location,
	locationLink,
	firstNationsLocation,
	projectStatus,
	infoContent,
}) => {
	return (
		<ContentBlockWrapper gridClassName="gap-y-5xl">
			<div className="col-span-full row-start-1 tablet-l:col-span-10">
				<h1 id={overviewId} className="text-h2 text-blue">
					Overview
				</h1>
			</div>
			<div className="col-span-full row-start-3 **:text-body-lg! tablet-l:col-span-6 tablet-l:row-start-2">
				<RenderLexicalContent data={introContent} layout="nested" />
			</div>
			<div className="col-span-full row-start-2 tablet-l:col-span-5 tablet-l:col-start-8 tablet-l:row-start-2">
				{procurementUrl && (
					<ButtonLink
						key="button"
						label="View procurement opportunities"
						intent="primary"
						icon={['fas', 'chevron-right']}
						href={procurementUrl}
						target="_blank"
						className="mb-xl"
					/>
				)}
				<div className="flex flex-col gap-y-lg pb-lg">
					{locationLink && (
						<InfoStrip title="Location" size="sm">
							<p>
								{/* Make it as plain text for now */}
								{location}
							</p>
							{firstNationsLocation && (
								<p>
									<i>{firstNationsLocation}</i>
								</p>
							)}
						</InfoStrip>
					)}
					{projectStatus && (
						<InfoStrip title="Project status" size="sm">
							<p>{projectStatus}</p>
						</InfoStrip>
					)}
				</div>
				<RenderLexicalContent data={infoContent} layout="nested" />
			</div>
		</ContentBlockWrapper>
	)
}
